import SubcategoryPage from '@/components/template/SubcategoryPage';

const VanityStool = () => {
  const products = [
    {
      title: "Vanity Stool Elegance",
      imageSrc: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80",
      url: "/proizvodi/vanity-stool-elegance"
    },
    {
      title: "Vanity Stool Comfort",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/vanity-stool-comfort"
    },
    {
      title: "Vanity Stool Luxe",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/vanity-stool-luxe"
    }
  ];

  return (
    <SubcategoryPage
      title="Vanity Stool"
      description="Elegantni toaletni stolčki, ki dodajo pridih razkošja vašemu prostoru za ličenje in nego."
      heroImage="https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default VanityStool;